import { Spinner as SpinnerComponent } from '@material-tailwind/react'

const Spinner = (props: any) => {
    return <SpinnerComponent {...props} />
}

export default Spinner
